module.exports = __webpack_public_path__ + "images/36c8503ea13c0ba1efdf67f67abc0cf5.svg";